import React from 'react';
import { ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList } from '@mui/material';
import CustomButton from '../Button/Button';
import './SplitButton.scss';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from 'clsx';

const SplitButton = (props) => {
    let { options, open = false, selectedIndex = 0, size, color, handleClick = () => { }, handleMenuItemClick, handleToggle, handleClose, className, placeholder = '', disabled, disablePortal = false, paperStyles } = props;
    const anchorRef = React.useRef(null);

    return (
        <React.Fragment>
            <ButtonGroup variant="outlined" color={color} ref={anchorRef} aria-label="split button" className={clsx(className, size, color)} disabled={disabled}>
                <CustomButton
                    onClick={handleClick}
                    variant="outlined"
                    size='full'
                    color={color}
                    className={clsx('split-btn-button', color)}
                    disabled={options[selectedIndex] && (options[selectedIndex].disabled || options[selectedIndex]['disabled'])}
                >
                    {
                        (selectedIndex >= 0)
                            ? (
                                <>
                                    {options[selectedIndex]?.icon && <FontAwesomeIcon icon={['fas', options[selectedIndex]?.icon]} />}
                                    {options[selectedIndex]?.label}
                                </>
                            )
                            : placeholder
                    }
                </CustomButton>
                <CustomButton
                    onClick={handleToggle}
                    variant="outlined"
                    size='large'
                    color={color}
                    className={clsx('split-btn-button', color)}
                >
                    <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                </CustomButton>
            </ButtonGroup>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement={'bottom-end'}
                transition
                className={'split-btn-popover'}
                disablePortal={disablePortal}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                        }}
                    >
                        <Paper style={paperStyles}>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option.value}
                                            className={clsx('split-btn-menu-item', color)}
                                            selected={index === selectedIndex}
                                            onClick={event => handleMenuItemClick(event, index)}
                                            disabled={option.disabled || option['disabled']}
                                        >
                                            {option?.icon && <FontAwesomeIcon icon={['fas', option.icon]} />}
                                            {option?.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    );
}

export default SplitButton;
